import { easings, useSpring, useTransition } from '@react-spring/web';

const useComplexAnimations = (isHovered: boolean) => {
  const { easeInSine } = easings;

  const showFiltersDesktopAnimation = useSpring({
    from: {
      left: '-100px',
    },
    to: {
      left: '0',
    },
    delay: 50,
    config: {
      duration: 100,
      easing: easeInSine,
    },
  });

  const showFiltersAdditionaAnimation = useSpring({});

  const textOpacityAnimation = useSpring({
    from: {
      opacity: 1,
    },
    to: {
      opacity: isHovered ? 1 : 0,
    },
    delay: 195,
    config: {
      duration: 100,
      easing: easeInSine,
    },
  });

  const textAppearenceAnimation = useSpring({
    from: {
      display: 'auto',
    },
    to: {
      display: isHovered ? 'none' : 'auto',
    },
    delay: 200,
    config: {
      duration: 150,
      easing: easeInSine,
    },
  });

  const hoverAnimation = useSpring({
    from: {
      height: isHovered ? '50px' : '100px',
    },
    to: {
      height: isHovered ? '100px' : '50px',
    },
    delay: 100,
    config: {
      duration: 200,
      easing: easeInSine,
    },
  });

  return {
    showFiltersDesktopAnimation,
    showFiltersAdditionaAnimation,
    textOpacityAnimation,
    textAppearenceAnimation,
    hoverAnimation,
  };
};

export default useComplexAnimations;
